import { AppLanguage, getPreferredLanguage } from '../language';

export interface LabelingPostOrderI18nTemplate {
  shared: {
    back: string;
    cancel: string;
    next: string;
  };
  previewOrder: {
    loadingPayment: string;
    cancelledLabelBlockedPayment: string;
    labelCreateFailed: string;
    paymentFailed: string;
    paymentProcessingNoRefresh: string;
    actionFailed: string;
    actionFailedRetry: string;
    containsCancelledLabel: string;
    pay: string;
    batchModifyTitle: string;
    batchModifyMessage: string;
    continueModify: string;
    batchModifyTipsTitle: string;
    batchModifyTip1: string;
    batchModifyTip2: string;
    batchModifyTip3: string;
    revokeOrder: string;
    applyRefund: string;
    guidanceTitle: string;
    guidanceDescription: string;
    avgPackagePriceTitle: string;
    totalOrderPriceTitle: string;
    savingsText: string;
    shippingRequirements: string;
    courier: string;
    senderAddress: string;
    packageDetailsTitle: string;
    modify: string;
    confirmRevokeTitle: string;
    confirmRefundTitle: string;
    confirmRevokeMessage: string;
    confirmRefundMessage: string;
    confirmRevoke: string;
    confirmRefund: string;
    orderInfo: string;
    orderNumber: string;
    packageCount: string;
    totalAmount: string;
    currentStatus: string;
    currentOrderStatus: string;
    operationFailedTitle: string;
    contactSupport: string;
    orderCancelled: string;
    refundSubmitted: string;
  };
  orderSuccess: {
    orderMissing: string;
    orderIdMissing: string;
    orderNumberMissing: string;
    labelProcessingRetry: string;
    labelFetchFailed: string;
    labelDownloadingStarted: string;
    labelFetchSuccess: string;
    operationFailed: string;
    applyRefund: string;
    cancelOrder: string;
    guidanceTitle: string;
    guidanceDescription: string;
    avgPackagePriceTitle: string;
    totalOrderPriceTitle: string;
    savingsText: string;
    shippingRequirements: string;
    courier: string;
    senderAddress: string;
    packageDetailsTitle: string;
    exportPackageInfo: string;
    downloadFailedRetryFile: string;
    failedRetryDownloadFailed: string;
    downloading: string;
    downloadAllLabels: string;
    confirmCancelTitle: string;
    confirmCancelMessage: string;
    confirmCancel: string;
    orderInfo: string;
    orderNumber: string;
    packageCount: string;
    currentStatus: string;
    uspsCancelFeeNotice: string;
    cancelOrderAfterTitle: string;
    cancelOrderAfterTip1: string;
    cancelOrderAfterTip2: string;
    uspsRefundRule: string;
    orderPaidSuccess: string;
    orderCancelled: string;
    refundSubmitted: string;
  };
  trackingInfo: {
    note: string;
  };
}

export const TEMPLATES: Record<AppLanguage, LabelingPostOrderI18nTemplate> = {
  zh: {
    shared: {
      back: '返回',
      cancel: '取消',
      next: '下一步',
    },
    previewOrder: {
      loadingPayment: '正在支付处理中，批量订单可能需要1-5分钟，请不要刷新或关闭页面...',
      cancelledLabelBlockedPayment: '订单中包含已取消的面单，无法完成支付。请重新创建订单。',
      labelCreateFailed: '面单创建失败，请稍后重试',
      paymentFailed: '支付失败，请重试或修改订单。',
      paymentProcessingNoRefresh: '支付正在处理，请不要刷新或关闭页面',
      actionFailed: '操作失败',
      actionFailedRetry: '操作失败，请稍后重试',
      containsCancelledLabel: '包含已取消面单',
      pay: '支付',
      batchModifyTitle: '修改批量订单',
      batchModifyMessage: '修改批量订单需要重新上传地址数据，是否继续？',
      continueModify: '继续修改',
      batchModifyTipsTitle: '修改批量订单时：',
      batchModifyTip1: '需要重新上传包含收件人地址的Excel文件',
      batchModifyTip2: '当前的包裹信息将被清除',
      batchModifyTip3: '发件人地址和快递偏好会保留',
      revokeOrder: '撤销该订单',
      applyRefund: '申请退款',
      guidanceTitle: '预览订单',
      guidanceDescription: '共 {{count}} 个包裹',
      avgPackagePriceTitle: '包裹均价 (补扣免责)',
      totalOrderPriceTitle: '订单总价 (补扣免责)',
      savingsText: '比门市价节省{{percent}}%',
      shippingRequirements: '快递需求',
      courier: '快递公司',
      senderAddress: '发货地址',
      packageDetailsTitle: '快递明细 · {{count}}个包裹',
      modify: '修改',
      confirmRevokeTitle: '确认撤销订单',
      confirmRefundTitle: '确认申请退款',
      confirmRevokeMessage: '确定要取消这个订单吗？此操作不可撤销。',
      confirmRefundMessage: '确定要申请退款吗？此操作不可撤销。',
      confirmRevoke: '确认撤销',
      confirmRefund: '确认退款',
      orderInfo: '订单信息：',
      orderNumber: '订单号',
      packageCount: '包裹数量',
      totalAmount: '总金额',
      currentStatus: '当前状态',
      currentOrderStatus: '当前订单状态',
      operationFailedTitle: '操作失败',
      contactSupport: '如需帮助，请联系客服',
      orderCancelled: '订单已成功取消',
      refundSubmitted: '退款申请已提交',
    },
    orderSuccess: {
      orderMissing: '订单不存在',
      orderIdMissing: '订单ID不存在',
      orderNumberMissing: '订单号不存在',
      labelProcessingRetry: '面单正在生成中，请稍后重试',
      labelFetchFailed: '获取面单失败',
      labelDownloadingStarted: '面单已开始下载',
      labelFetchSuccess: '面单获取成功',
      operationFailed: '操作失败',
      applyRefund: '申请退款',
      cancelOrder: '取消订单',
      guidanceTitle: '订单 {{orderNumber}}',
      guidanceDescription: '共 {{count}} 个包裹',
      avgPackagePriceTitle: '包裹均价',
      totalOrderPriceTitle: '订单总价',
      savingsText: '比门市价节省{{percent}}%',
      shippingRequirements: '快递需求',
      courier: '快递公司',
      senderAddress: '发货地址',
      packageDetailsTitle: '快递明细 · {{count}}个包裹',
      exportPackageInfo: '导出包裹信息',
      downloadFailedRetryFile: '下载失败订单信息',
      failedRetryDownloadFailed: '下载失败订单信息失败，请稍后重试',
      downloading: '下载中...',
      downloadAllLabels: '下载全部面单',
      confirmCancelTitle: '确认取消订单',
      confirmCancelMessage: '确定要取消这个订单吗？此操作不可撤销。',
      confirmCancel: '确认取消',
      orderInfo: '订单信息：',
      orderNumber: '订单号',
      packageCount: '包裹数量',
      currentStatus: '当前状态',
      uspsCancelFeeNotice: '注意：订单中包含USPS面单，取消将收取10%手续费',
      cancelOrderAfterTitle: '取消该订单后：',
      cancelOrderAfterTip1: '该订单将无法恢复',
      cancelOrderAfterTip2: '需要重新创建订单',
      uspsRefundRule: 'USPS面单退款金额 = 原金额 × 90%',
      orderPaidSuccess: '订单支付成功！',
      orderCancelled: '订单已成功取消',
      refundSubmitted: '退款申请已提交',
    },
    trackingInfo: {
      note: 'TrackingInfo 当前沿用 order.ts 模板（历史实现）',
    },
  },
  en: {
    shared: {
      back: 'Back',
      cancel: 'Cancel',
      next: 'Next',
    },
    previewOrder: {
      loadingPayment:
        'Payment is processing. Large batch orders may take 1-5 minutes. Please do not refresh or close this page...',
      cancelledLabelBlockedPayment:
        'This order includes cancelled labels and cannot be paid. Please create a new order.',
      labelCreateFailed: 'Failed to create labels. Please try again later.',
      paymentFailed: 'Payment failed. Please retry or modify the order.',
      paymentProcessingNoRefresh: 'Payment is processing. Please do not refresh or close this page.',
      actionFailed: 'Operation failed.',
      actionFailedRetry: 'Operation failed. Please try again later.',
      containsCancelledLabel: 'Contains Cancelled Labels',
      pay: 'Pay',
      batchModifyTitle: 'Modify Batch Order',
      batchModifyMessage:
        'Modifying a batch order requires re-uploading address data. Continue?',
      continueModify: 'Continue',
      batchModifyTipsTitle: 'When modifying a batch order:',
      batchModifyTip1: 'You need to re-upload the Excel file with recipient addresses.',
      batchModifyTip2: 'Current package info will be cleared.',
      batchModifyTip3: 'Sender address and courier preferences will be kept.',
      revokeOrder: 'Cancel Order',
      applyRefund: 'Request Refund',
      guidanceTitle: 'Preview Order',
      guidanceDescription: '{{count}} packages total',
      avgPackagePriceTitle: 'Average Package Price',
      totalOrderPriceTitle: 'Total Order Price',
      savingsText: 'Save {{percent}}% vs retail rate',
      shippingRequirements: 'Shipping Requirements',
      courier: 'Courier',
      senderAddress: 'Sender Address',
      packageDetailsTitle: 'Package Details · {{count}} packages',
      modify: 'Modify',
      confirmRevokeTitle: 'Confirm Order Cancellation',
      confirmRefundTitle: 'Confirm Refund Request',
      confirmRevokeMessage: 'Cancel this order? This action cannot be undone.',
      confirmRefundMessage: 'Request a refund? This action cannot be undone.',
      confirmRevoke: 'Confirm Cancellation',
      confirmRefund: 'Confirm Refund',
      orderInfo: 'Order Info:',
      orderNumber: 'Order Number',
      packageCount: 'Package Count',
      totalAmount: 'Total Amount',
      currentStatus: 'Current Status',
      currentOrderStatus: 'Current Order Status',
      operationFailedTitle: 'Operation Failed',
      contactSupport: 'Please contact support if you need help.',
      orderCancelled: 'Order cancelled successfully.',
      refundSubmitted: 'Refund request submitted.',
    },
    orderSuccess: {
      orderMissing: 'Order not found.',
      orderIdMissing: 'Order ID is missing.',
      orderNumberMissing: 'Order number is missing.',
      labelProcessingRetry: 'Labels are still processing. Please try again later.',
      labelFetchFailed: 'Failed to fetch labels.',
      labelDownloadingStarted: 'Label download has started.',
      labelFetchSuccess: 'Labels fetched successfully.',
      operationFailed: 'Operation failed.',
      applyRefund: 'Request Refund',
      cancelOrder: 'Cancel Order',
      guidanceTitle: 'Order {{orderNumber}}',
      guidanceDescription: '{{count}} packages total',
      avgPackagePriceTitle: 'Average Package Price',
      totalOrderPriceTitle: 'Total Order Price',
      savingsText: 'Save {{percent}}% vs retail rate',
      shippingRequirements: 'Shipping Requirements',
      courier: 'Courier',
      senderAddress: 'Sender Address',
      packageDetailsTitle: 'Package Details · {{count}} packages',
      exportPackageInfo: 'Export Package Info',
      downloadFailedRetryFile: 'Download Failed Retry File',
      failedRetryDownloadFailed: 'Failed to download retry file. Please try again.',
      downloading: 'Downloading...',
      downloadAllLabels: 'Download All Labels',
      confirmCancelTitle: 'Confirm Order Cancellation',
      confirmCancelMessage: 'Cancel this order? This action cannot be undone.',
      confirmCancel: 'Confirm Cancellation',
      orderInfo: 'Order Info:',
      orderNumber: 'Order Number',
      packageCount: 'Package Count',
      currentStatus: 'Current Status',
      uspsCancelFeeNotice:
        'Notice: This order includes USPS labels. Cancellation will incur a 10% fee.',
      cancelOrderAfterTitle: 'After cancellation:',
      cancelOrderAfterTip1: 'This order cannot be restored.',
      cancelOrderAfterTip2: 'You need to create a new order.',
      uspsRefundRule: 'USPS refund amount = original amount × 90%',
      orderPaidSuccess: 'Order paid successfully.',
      orderCancelled: 'Order cancelled successfully.',
      refundSubmitted: 'Refund request submitted.',
    },
    trackingInfo: {
      note: 'TrackingInfo currently uses order.ts template (previous implementation)',
    },
  },
};

export const LABELING_POST_ORDER_NAMESPACE = 'labelingPostOrder';
export const LABELING_POST_ORDER_RESOURCE_KEY = 'template';

export const LABELING_POST_ORDER_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof LABELING_POST_ORDER_RESOURCE_KEY, LabelingPostOrderI18nTemplate>
> = {
  zh: {
    [LABELING_POST_ORDER_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [LABELING_POST_ORDER_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getLabelingPostOrderTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): LabelingPostOrderI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
